export default function HotelPricing({ price }) {
	return (
		<>
			{price && (
				<div className="">
					<p className="text-primary font-medium">
						AED {price.split(" ")[0] ?? price}
					</p>
				</div>
			)}
		</>
	);
}
